export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/node_modules/redux-form/es/util/eventConsts.js
// module id = 1814
// module chunks = 1